// yetkiYonlendirme.js — yetkisiz bir sayfada kalan kullanıcıyı görebileceği bir
// sayfaya taşır.
//
// İSTEK (kullanıcı, 2026-08-04): "yanlış bir sayfaya girdi, yetkiniz yok dedi, güzel —
// ama göreceği bir sayfaya yönlendirme de olsun." Yalnızca uyarı gösterip boş ekranda
// bırakmak kullanıcıyı çıkmaz sokakta tutuyordu.
//
// 🔴 BU KODUN TEK GERÇEK RİSKİ DÖNGÜ. Bir 403'e yönlendirmeyle cevap vermek, hedef
// sayfa da 403 verirse sonsuza gider. Üç ayrı fren var:
//
//   F1  YALNIZCA SAYFA AÇILIŞINDAKİ 403. Bir butona basınca gelen 403 kullanıcıyı
//       sayfadan ATMAMALI — o sadece "bu işlemi yapamazsın" demek, sayfa görüntülenebilir
//       olabilir. Bu yüzden yönlendirme, adres değişiminden sonraki kısa pencerede
//       (AÇILIS_PENCERESI_MS) gelen 403'lerle sınırlı.
//   F2  HEDEFTEYSEK YÖNLENDİRME YOK. Güvenli sayfanın kendisi 403 veriyorsa taşınacak
//       yer yok; uyarı kalır, kullanıcı sistemde kalır.
//   F3  PENCERE BAŞINA TEK YÖNLENDİRME. Bir sayfa açılışında onlarca istek 403 dönebilir;
//       hepsi ayrı ayrı yönlendirme denerse adres ping-pong yapar.
//
// Güvenli sayfa `defaultPage`: girişte BE tarafından role göre hesaplanıp
// localStorage'a yazılıyor, rol değişiminde de güncelleniyor (bkz. bildirimRol.js).

import { isAuth } from "./auth";

const AÇILIS_PENCERESI_MS = 6000;
const YONLENDIRME_ARALIGI_MS = 10000;
const GUVENLI_SAYFA = "home";

let sonAcilisZamani = 0;
let sonYonlendirmeZamani = 0;

// --- Rol geçişi bayrağı -----------------------------------------------------
// BURADA DURUYOR, bildirimRol.js'te DEĞİL: bayrağı ihtiyaç duyan iki taraf
// `bildirimRol.js` ile `component/yeni/Istek.js`, ve bildirimRol.js zaten Istek.js'ten
// `apiRooter` alıyor. Bayrak bildirimRol.js'te kalsaydı Istek.js ↔ bildirimRol.js
// DÖNGÜSEL import olurdu; ES modülleri bunu çalıştırır ama modül yükleme sırasına bağlı
// olarak `undefined` bağ verebilir — sessiz ve teşhisi zor bir kırılma.
let rolGecisiSuruyor = false;
export const rolGecisiBasladi = () => { rolGecisiSuruyor = true; };
export const rolGecisiBitti = () => { rolGecisiSuruyor = false; };
/** 403 işleyicisi için: şu an bir rol geçişi sürüyor mu? */
export const rolGecisiSuruyorMu = () => rolGecisiSuruyor;

/**
 * Adres değiştiğinde çağrılır (PrivateRoute). "Sayfa şu an açıldı" bilgisi olmadan
 * sayfa açılışındaki 403 ile buton 403'ünü ayırmanın bir yolu yok.
 */
export const sayfaAcilisiniIsaretle = () => {
  sonAcilisZamani = Date.now();
};

// "/projeId/ayarlar/16" -> "ayarlar"
const mevcutSayfaSegmenti = () => {
  const parcalar = window.location.pathname.split("/").filter(Boolean);
  const indeks = parcalar.indexOf("projeId");
  return indeks >= 0 ? parcalar[indeks + 1] || "" : parcalar[0] || "";
};

/**
 * 403 sonrası güvenli sayfaya taşı. Koşullar sağlanmazsa hiçbir şey yapmaz —
 * çağıran taraf karar vermek zorunda değil.
 *
 * @returns {boolean} yönlendirme yapıldıysa true (çağıran mesajı buna göre seçebilir)
 */
export const yetkisizYonlendir = () => {
  const kullanici = isAuth();
  if (!kullanici) return false; // oturum yok -> 401 akışı ilgilenir

  // Rol geçişi sürerken yönlendirme YOK: sayfa eski rolle veri istemiş olabilir ve
  // geçiş bitince zaten yenilenecek. Buradan taşımak, kullanıcıyı tıkladığı bildirimin
  // hedefinden atmak demek olurdu.
  if (rolGecisiSuruyor) return false;

  const simdi = Date.now();
  if (simdi - sonAcilisZamani > AÇILIS_PENCERESI_MS) return false; // F1
  if (simdi - sonYonlendirmeZamani < YONLENDIRME_ARALIGI_MS) return false; // F3

  const hedef = kullanici.defaultPage || GUVENLI_SAYFA;
  if (!hedef || hedef === mevcutSayfaSegmenti()) return false; // F2

  sonYonlendirmeZamani = simdi;
  // Kısa gecikme: "yetkiniz yok" uyarısı görünmeden sayfa değişmesin. Aynı gerekçe
  // signout() içindeki 800 ms için de geçerli (bkz. helpers/auth.js).
  setTimeout(() => {
    window.location.assign(`/projeId/${hedef}`);
  }, 1200);
  return true;
};
